/* eslint-disable */
import { CustomValidators } from 'shared/validation/custom-validators';


export const fitmentSegmentData: any = [
  {
    'field_map': 'mfr_label',
    'item_name': 'assignment_values.mfr_label',
    'title': 'Manufacturer label',
    'hint_detail': 'Manufacturer label',
    'hint_panel' : 'Manufacturer label',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'lookup': null,
    'maxLength': 500,
    'validation': {
        'ACES_3_2': {
            maxLength: 500,
            message: 'Manufacturer label is limited to 500 characters',
        },
        'ACES_3_0': {
            maxLength: 500,
            message: 'Manufacturer label is limited to 500 characters',
        },
    }
  },
  {
    'field_map': 'position_id',
    'item_name': 'assignment_values.position_id',
    'title': 'Position',
    'hint_detail': 'Position',
    'hint_panel' : 'Position',
    'example': '',
    'sequence': 2,
    'show_more': true,
    'lookup': [],
  },
  {
    'field_map': 'notes',
    'item_name': 'assignment_values.notes',
    'title': 'Notes',
    'hint_detail': 'Notes',
    'hint_panel' : 'Notes',
    'example': '',
    'sequence': 3,
    'show_more': true,
    'lookup': null,
    'maxLength': 500,
    'validation': {
        'ACES_3_2': {
            maxLength: 500,
            message: 'Notes must be less than 500',
        },
        'ACES_3_0': {
            maxLength: 500,
            message: 'Notes must be less than 500',
        },
    },
  },
  {
    'field_map': 'qty',
    'item_name': 'assignment_values.qty',
    'title': 'Per Car Quantity',
    'hint_detail': 'Per Car Quantity',
    'hint_panel' : 'Per Car Quantity',
    'example': '',
    'numerical': true,
    'sequence': 5,
    'show_more': true,
    'lookup': null,
    'validation': {
        'ACES_3_2': {
            validator: CustomValidators.digits,
            min: 1,
            max: 20,
            message: 'Per Car Quantity must be greater than 0 and less than 20',
        },
        'ACES_3_0': {
            validator: CustomValidators.digits,
            min: 1,
            max: 20,
            message: 'Per Car Quantity must be greater than 0 and less than 20',
        },
    },
  },
  {
    'field_map': 'partTerminologies',
    'item_name': 'assignment_values.part_terminologies',
    'title': 'Part type',
    'hint_detail': 'The part terminology name',
    'hint_panel' : 'The part terminology name',
    'example': '',
    'sequence': '',
    'show_more': true,
    'lookup': null
  },
];

/* eslint-enable */
